import { Outlet } from 'react-router-dom';
import { useState, useEffect } from 'react';
import RingLoader from 'react-spinners/RingLoader';
import useRefreshToken from '../hooks/useRefreshToken';
import useAuth from '../hooks/useAuth';

const PersistLogin = () => {
  const [isLoading, setIsLoading] = useState(true);
  const refresh = useRefreshToken();
  const { auth, persist } = useAuth();

  useEffect(() => {
    const verifyRefreshToken = async () => {
      try {
        await refresh();
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
      }
    };

    if (!auth?.accessToken && persist) {
      verifyRefreshToken();
    } else {
      setIsLoading(false);
    }
  }, []);

  return (
    <>
      {!persist
        ? <Outlet />
        : isLoading
          ? (
            <p>
              <RingLoader
                style={{
                  position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
                }}
                color="#2f2fa2"
              />
            </p>
          )
          : <Outlet />}
    </>
  );
};

export default PersistLogin;
